"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _lodash = _interopRequireDefault(require("lodash"));
var _servicesListMixin = require("@/mixins/servicesListMixin");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  name: 'ServicesList',
  bodyClass: 'services-list-page',
  components: {
    CardMonitor: _components.CardMonitor,
    FieldSearchInput: _components.FieldSearchInput
  },
  mixins: [_servicesListMixin.servicesListMixin],
  data: function data() {
    return {
      filter: ''
    };
  },
  computed: {
    listServicesAll: function listServicesAll() {
      return _lodash.default.orderBy(this.listServices, ['name']);
    },
    list: function list() {
      var _this = this;
      if (this.filter.length) {
        return this.listServicesAll.filter(function (p) {
          return p.name.toUpperCase().indexOf(_this.filter.toUpperCase()) >= 0;
        });
      }
      return this.listServicesAll;
    }
  },
  methods: {
    getMillisecongs: function getMillisecongs() {
      return Math.floor(Math.random() * 10);
    },
    openDetailService: function openDetailService(item) {
      this.$router.push({
        path: "/connection-service-detail/".concat(item._id)
      });
    }
  }
};